var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRegistration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.75C6.20507 1.75 4.75 3.20507 4.75 5C4.75 6.79493 6.20507 8.25 8 8.25C9.79493 8.25 11.25 6.79493 11.25 5C11.25 3.20507 9.79493 1.75 8 1.75ZM3.25 5C3.25 2.37665 5.37665 0.25 8 0.25C10.6234 0.25 12.75 2.37665 12.75 5C12.75 7.62335 10.6234 9.75 8 9.75C5.37665 9.75 3.25 7.62335 3.25 5ZM5 13.75C3.20507 13.75 1.75 15.2051 1.75 17C1.75 17.6904 2.30964 18.25 3 18.25H13C13.6904 18.25 14.25 17.6904 14.25 17C14.25 15.2051 12.7949 13.75 11 13.75H5ZM0.25 17C0.25 14.3766 2.37665 12.25 5 12.25H11C13.6234 12.25 15.75 14.3766 15.75 17C15.75 18.5188 14.5188 19.75 13 19.75H3C1.48122 19.75 0.25 18.5188 0.25 17ZM22.5303 6.53033C22.8232 6.23744 22.8232 5.76256 22.5303 5.46967C22.2374 5.17678 21.7626 5.17678 21.4697 5.46967L18 8.93934L16.5303 7.46967C16.2374 7.17678 15.7626 7.17678 15.4697 7.46967C15.1768 7.76256 15.1768 8.23744 15.4697 8.53033L17.4697 10.5303C17.7626 10.8232 18.2374 10.8232 18.5303 10.5303L22.5303 6.53033Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistration);
export default __webpack_public_path__ + "static/media/registration.d674c79f9422891068135b763c9b531d.svg";
export { ForwardRef as ReactComponent };